import InputWrapper from "./component-library17.mjs";
import LabeledInput from "./component-library16.mjs";
import normalizeComponent from "./component-library80.mjs";
const _sfc_main = {
  components: { InputWrapper },
  mixins: [LabeledInput],
  props: {
    value: {
      type: String,
      default: null
    },
    minlength: { type: Number, default: null },
    type: { type: String, default: "text" }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("InputWrapper", _vm._b({ scopedSlots: _vm._u([{ key: "default", fn: function({ id }) {
    return [_c("input", _vm._b({ ref: "primaryInput", staticClass: "input-wrapper__input", class: _vm.inputClass, attrs: { "id": id }, on: { "input": _vm.onInput } }, "input", _vm.inputFiledProps, false))];
  } }]) }, "InputWrapper", _vm.inputWrapperProps, false));
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const textInput = __component__.exports;
export {
  textInput as default
};
